import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {StorageService} from "../services/storage.service";

@Injectable()
export class AuthGuard {
    constructor(private router: Router,
        private storageService: StorageService) { }



    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const user = this.storageService.getCurrentUser();
      // if (this.storageService.isAuthenticated()) {
      //   return true;
      // }
      // this.router.navigate(['/login']);
      // return false;

      if (!this.storageService.isAuthenticated()) {
        this.router.navigate(['/login']);
        return false;
      }

      if (!user || !user.rol || typeof user.rol !== 'number') { 
        this.setLogoutSession();
        return false;
      }

      const rolIdUsuario = user.rol;
      const rolesPermitidos = route.data && route.data['roles'];
      // const permisosRequeridos = route.data && route.data['permisos'];

      if (rolesPermitidos && !rolesPermitidos.includes(rolIdUsuario)) {
        this.setLogoutSession();
        return false;
      }

      if (rolIdUsuario === 1 || rolIdUsuario === 2 || rolIdUsuario === 3) {
        return true;
      }

      return true;
    }

    setLogoutSession() {
      this.storageService.logout();
    }
}




// WEBPACK FOOTER //
// ./src/app/guards/auth-guard.ts